/* eslint-disable max-statements */
import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {
  Card,
  Grid,
  Dropdown,
  Label,
  Divider,
  Button,
} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {yearsOptions} from '../../common/constants/years';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import './style.scss';

const {calendarListByYear, navigateTo} = Actions;

const areaOption = [
  {'key': '1', 'value': 'REPUESTOS', 'text': 'REPUESTOS'},
  {'key': '2', 'value': 'LOGISTICA', 'text': 'LOGISTICA'},
  {'key': '3', 'value': 'VEHICULOS', 'text': 'VEHICULOS'},
];

const CardContent = ({color, title, days}) => {
  return (
    <div>
      <Label color={color}>
        <div className='calendarioTems-sb'>
          <span>{title}</span>
          <span>{days}</span>
        </div>
      </Label>
    </div>
  );
};

const CardCalendar = (props) => {
  const {month, days, daysOff, monthNumber, year, area} = props;
  return (
    <Link
      to={`/calendario-tems-detalle?month=${monthNumber}&year=${year}&area=${area}`}
    >
      <Card>
        <Card.Content>
          <Card.Header>{month}</Card.Header>
          <Card.Description>
            <CardContent color='blue' title='Días Laborables' days={days} />
            <Divider horizontal inverted></Divider>
            <CardContent title='Días No Laborables' days={daysOff} />
          </Card.Description>
        </Card.Content>
      </Card>
    </Link>
  );
};

const TdeCalendar = () => {
  const [year, setYear] = useState(moment().year());
  const [area, setArea] = useState('LOGISTICA');
  const [disable, setDisable] = useState(true);
  const permissions = useSelector((state) => state.session.permissions);
  const listCalendar = useSelector((state) => state.listCalendar);
  const {list, loading} = listCalendar;
  const totalDays = list.reduce((acc, month) => acc + month.days, 0);
  const totalDaysOff = list.reduce((acc, month) => acc + month.daysOff, 0);
  const dispatch = useDispatch();

  useEffect(() => {
    let flat = 0;
    if (
      !hasAccessPermission(
        permissions,
        resources.TdeCalendar,
        scopes.See
      )
    ) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    if (
      hasAccessPermission(
        permissions,
        resources.TdeCalendarCPD,
        scopes.See
      )
    ) {
      setArea('REPUESTOS');
      dispatch(calendarListByYear(year, 'REPUESTOS'));
      flat = flat + 1;
    }
    if (
      hasAccessPermission(
        permissions,
        resources.TdeCalendarLOG,
        scopes.See
      )
    ) {
      setArea('LOGISTICA');
      dispatch(calendarListByYear(year, 'LOGISTICA'));
      flat = flat + 1;
    }
    if (
      hasAccessPermission(
        permissions,
        resources.TdeCalendarVEH,
        scopes.See
      )
    ) {
      setArea('VEHICULOS');
      dispatch(calendarListByYear(year, 'VEHICULOS'));
      flat = flat + 1;
    }
    if (flat >= 2) {
      setDisable(false);
    }
  }, [dispatch]);

  const onSearch = () => {
    dispatch(calendarListByYear(year, area));
  };

  if (loading) {
    return <h1>Cargando</h1>;
  }

  return (
    <div>
      <Card raised fluid>
        <Grid columns={6} padded>
          <Grid.Row>
            <Grid.Column>
              <h1>Calendario de</h1>
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                selection
                search
                value={area}
                onChange={(e, {value}) => setArea(value)}
                label='Seleccionar area'
                options={areaOption}
                placeholder='seleccionar area'
                disabled={disable}
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                selection
                search
                value={year}
                onChange={(e, {value}) => setYear(value)}
                label='Seleccionar año'
                options={yearsOptions}
                placeholder='Seleccionar año'
              />
            </Grid.Column>
            <Grid.Column>
              <div className='title-bar-actions'>
                <Button
                  primary
                  className='toyota-primary'
                  disabled={loading}
                  onClick={onSearch}
                >
                  Consultar
                </Button>
              </div>
            </Grid.Column>
            <Grid.Column verticalAlign='middle'>
              <Label color='blue'>Días laborables {totalDays}</Label>
            </Grid.Column>
            <Grid.Column verticalAlign='middle'>
              <Label color='grey'>Días no laborables {totalDaysOff}</Label>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
      <Card raised fluid>
        <Grid columns={4} padded>
          <Grid.Row>
            {list.map((month, index) => {
              return (
                <Grid.Column key={index}>
                  <div className='calendarioTems-Space'>
                    <CardCalendar {...month} area={area} />
                  </div>
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </Grid>
      </Card>
    </div>
  );
};

export default TdeCalendar;
